import { HeaderAccordions } from '../components/sections/HeaderAccordions'
import UnavailableSectionsBanner from '../components/sections/UnavailableSectionsBanner'
import HeroSection from '../components/sub-sections/hero/HeroSection'
import {
  MutualFundDetailSections,
  MutualFundDetailSectionsType,
  MutualFundDetailSubSections
} from '../types/mutual-fund-detail.types'
import NewPreEliteCard from '../components/sections/NewPreEliteCard'
import FundHoldings from '../components/sections/FundHoldings'
import FundInformation from '../components/sections/FundInformation'
import FundObjective from '../components/sections/FundObjective'
import RollingReturnsSection from '../components/sub-sections/rolling-returns/RRSection'
import TrailingReturnsSection from '../components/sub-sections/trailing-returns/TRSection'
import Alerts from '../components/sub-sections/alerts/Alerts'
import { ReturnsGraph } from '../components/sections/ReturnsGraph'
import InvestmentSection from '../features/user-investment/components/InvestmentSection'
import { Taxes } from '../components/sub-sections/taxes/Taxes'
import DistributionSection from '../components/sub-sections/distribution/DistributionSection'
import { FundManagers } from '../components/sub-sections/fund-manager/FundManagers'
import { AboutFund } from '../components/sub-sections/about-fund/AboutFund'
import { AdvancedRatios } from '../components/sub-sections/advanced-ratios/AdvancedRatios'
import * as React from 'react'
import HoldingsSection from '../components/sub-sections/holdings/HoldingsSection'
import { SuggestedHoldingPeriod } from '../components/sub-sections/suggested-holding-period/SuggestedHoldingPeriod'
import { MarketOutperformance } from '../components/sub-sections/market-outperformance/MarketOutperformance'

export const sectionsConfig: Record<`${MutualFundDetailSections}`, React.FC<any>> = {
  [MutualFundDetailSections.HEADER_ACCORDIONS]: HeaderAccordions,
  [MutualFundDetailSections.UNAVAILABLE_SECTIONS]: UnavailableSectionsBanner,
  [MutualFundDetailSections.ELITE_STATS]: NewPreEliteCard,
  [MutualFundDetailSections.FUND_HOLDINGS]: FundHoldings,
  [MutualFundDetailSections.FUND_INFORMATION]: FundInformation,
  [MutualFundDetailSections.FUND_OBJECTIVE]: FundObjective,
  [MutualFundDetailSections.RETURNS_GRAPH]: ReturnsGraph
}

export const renderSection = (section: MutualFundDetailSectionsType[0]) => {
  const sectionKey = section?.section
  const SectionComponent = sectionsConfig?.[sectionKey]
  return SectionComponent ? (
    <SectionComponent key={`${sectionKey}`} sectionKey={sectionKey} subsections={section?.subSections} />
  ) : null
}

export const subSectionsConfig: {
  [x in `${MutualFundDetailSubSections}`]: React.FC<any>
} = {
  [MutualFundDetailSubSections.MY_INVESTMENTS]: InvestmentSection,
  [MutualFundDetailSubSections.POWER_PERFORMANCE]: HeroSection,
  [MutualFundDetailSubSections.ALERTS]: Alerts,
  [MutualFundDetailSubSections.TRAILING_RETURNS]: TrailingReturnsSection,
  [MutualFundDetailSubSections.ROLLING_RETURNS]: RollingReturnsSection,
  [MutualFundDetailSubSections.SUGGESTED_HOLDING_PERIOD]: SuggestedHoldingPeriod,
  [MutualFundDetailSubSections.MARKET_OUT_PERFORMANCE]: MarketOutperformance,
  [MutualFundDetailSubSections.CONSISTENCY]: Taxes,
  [MutualFundDetailSubSections.VOLATILITY]: Taxes,
  [MutualFundDetailSubSections.RECENCY]: Taxes,
  [MutualFundDetailSubSections.HOLDINGS]: HoldingsSection,
  [MutualFundDetailSubSections.ASSET_ALLOCATION]: DistributionSection,
  [MutualFundDetailSubSections.ADVANCED_RATIOS]: AdvancedRatios,
  [MutualFundDetailSubSections.TAXES]: Taxes,
  [MutualFundDetailSubSections.TAX_LIABILITY]: () => null,
  [MutualFundDetailSubSections.FUND_MANAGERS]: FundManagers,
  [MutualFundDetailSubSections.ABOUT_FUND]: AboutFund
}

export const renderSubSection = ({
  componentKey,
  customProps
}: {
  componentKey: `${MutualFundDetailSubSections}`
  customProps?: Record<any, any>
}) => {
  const SectionComponent = subSectionsConfig?.[componentKey] ?? null
  return SectionComponent ? <SectionComponent key={`${componentKey}`} {...customProps} /> : null
}
